<ng-container>
  @if ((this.accounts$ | async); as accounts) {
    <div class="teams-permission-list">
      @for (account of accounts; track account) {
        <article class="teams-permission-row">
          <div class="teams-permission-identity">
            <span class="teams-permission-avatar">{{ this.getAccountInitials(account) }}</span>
            <div>
              <div class="teams-permission-name">{{ account.name || 'Connected Account' }}</div>
              <div class="teams-permission-email">{{ account.unique_name }}</div>
            </div>
          </div>
          @if (this.getPermissionChips(account).length) {
            <div class="teams-permission-chip-list">
              @for (chip of this.getPermissionChips(account); track chip) {
                <span class="teams-permission-chip" [class.is-warning]="chip === 'Needs attention'">
                  {{ chip }}
                </span>
              }
            </div>
          } @else {
            <div class="teams-permission-empty">No permissions assigned</div>
          }
          @if (account.error || account.pa_error) {
            <div class="teams-permission-issues">
              <a class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-white rounded-lg shadow hover:bg-slate-50 border-0 cursor-pointer transition-colors no-underline" [href]="this.authUrl + '?domain_hint=' + ((this.user$ | async)?.tid || '') + '&login_hint=' + account.unique_name + '&s=' + encodeStateParam('multi')">
                Reconnect Power Automate + Power Apps
              </a>
            </div>
          }
        </article>
      }
      @if (accounts.length === 0) {
        <article class="teams-permission-row teams-permission-row-add">
          <div>
            <div class="teams-permission-name">New Permissions</div>
            <div class="teams-permission-email">Add delegated access for Power Automate and Power Apps scanning.</div>
          </div>
          <div class="teams-permission-add-actions">
            <a class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-white rounded-lg shadow hover:bg-slate-50 border-0 cursor-pointer transition-colors no-underline" [href]="this.authUrl + '?domain_hint=' + ((this.user$ | async)?.tid || '') + '&login_hint=' + ((this.user$ | async)?.username || '') + '&s=' + encodeStateParam('multi')">
              Add Power Automate + Power Apps
            </a>
          </div>
        </article>
      }
    </div>
  }
</ng-container>
